import React, { memo } from 'react';

import { AdFoxBanner } from '../../../../../../components/AdfoxBanner';
import { AdfoxContextProvider, AdfoxContextProviderProps } from '../../../../../../utils/AdfoxContext';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'between_offers',
  place__DEPRECATED: 'offersSerp',
  name__DEPRECATED: 'Listing_native_TGB',
  extra__DEPRECATED: {
    offerType: 'TGB_banner',
  },
};
const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: '376px' };
const P_PARAMS_NEWBUILDING: AdfoxContextProviderProps['pParams'] = { p1: 'davxz', p2: 'fkhj' };
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'ddcfw', p2: 'fkhj' };

type TGBBannerProps = {
  isNewbuilding: boolean;
  position: number;
};

export const TGBBanner = memo<TGBBannerProps>(function TGBBanner(props) {
  const { isNewbuilding, position } = props;

  return (
    <AdfoxContextProvider
      size={SIZE}
      pParams={isNewbuilding ? P_PARAMS_NEWBUILDING : P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
    >
      <AdFoxBanner position={position} />
    </AdfoxContextProvider>
  );
});
